import { Box, Button, Typography, useTheme } from '@mui/material';
import useResponsive from '@/components/hooks/useResponsive';
import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';
import { AnalyticsEventName, CtaLocation, CtaText, ScreenName } from '@/types/enums';
import Images from './Images';

export const howItWorksData = [
  {
    key: 0,
    headline: 'Post a job',
    description: 'Tell us exactly what you need, and let caregivers apply directly.',
  },
  {
    key: 1,
    headline: 'Compare profiles',
    description: 'From experience and trainings to location and pay.',
  },
  {
    key: 2,
    headline: 'Read reviews',
    description: 'No need to ask around, see what others have said.',
  },
];

const HowItWorks = ({
  setOpenModalOrDrawer,
}: {
  setOpenModalOrDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const theme = useTheme();
  const { isMobile } = useResponsive();

  const handleClick = () => {
    AnalyticsHelper.logEvent({
      name: AnalyticsEventName.CTA_INTERACTED_VHP,
      data: {
        screen_name: ScreenName.VISITOR_HOMEPAGE,
        enrollment_initiated: true,
        cta_text: CtaText.GET_STARTED,
        cta_location: CtaLocation.VHP_BODY,
        vertical: 'Unknown',
      },
    });

    setOpenModalOrDrawer(true);
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.secondary,
        display: { md: 'flex' },
        justifyContent: { md: 'center' },
        overflow: 'hidden',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'center' },
          height: { sm: '648px', md: '552px' },
          justifyContent: { sm: 'space-between' },
          maxWidth: { md: '1271px' },
          width: { md: '100%' },
        }}>
        <Box
          sx={{
            display: { sm: 'flex' },
            flexDirection: { sm: 'column' },
            justifyContent: { sm: 'center' },
            height: { sm: '456px', md: '428px' },
            minWidth: { xs: '327px', sm: '469px', md: '625px' },
            px: { xs: 3, sm: 4 },
            py: { xs: 6, sm: 0 },
            ml: { sm: 4 },
            mr: { sm: 4, md: 0 },
          }}>
          <Typography variant={isMobile ? 'display3' : 'display2'} sx={{ margin: 0 }}>
            Find care on your terms
          </Typography>

          <Box mt={4}>
            {howItWorksData.map((item) => (
              <Box key={item.key} mb={isMobile ? 4 : 3}>
                <Typography variant="h2">{item.headline}</Typography>
                <Typography variant="body1" mt={1}>
                  {item.description}
                </Typography>
              </Box>
            ))}
          </Box>

          <Button
            sx={{ width: { sm: '171px' } }}
            onClick={handleClick}
            variant="contained"
            size="large"
            fullWidth={isMobile}>
            Get started
          </Button>
        </Box>

        <Box
          sx={{
            overflow: 'hidden',
          }}>
          <Images />
        </Box>
      </Box>
    </Box>
  );
};

export default HowItWorks;
